import { toast } from 'react-toastify'

const success = (message, options) => {
  toast.success(message, options)
}

export default success
